import { useEffect } from 'react';

const useOutsideClickClose = ({
  isOpen,
  onClose,
  shouldIgnoreTarget,
  containerRef,
}) => {
  useEffect(() => {
    if (!isOpen) {
      return () => {};
    }

    const handleOutside = (event) => {
      const target = event?.target;
      if (typeof shouldIgnoreTarget === 'function' && shouldIgnoreTarget(target)) {
        return;
      }

      if (containerRef?.current && containerRef.current.contains(target)) {
        return;
      }

      onClose?.();
    };

    document.addEventListener('mousedown', handleOutside);
    return () => {
      document.removeEventListener('mousedown', handleOutside);
    };
  }, [isOpen, onClose, shouldIgnoreTarget, containerRef]);
};

export default useOutsideClickClose;
